module.exports = __webpack_public_path__ + "img/bg-gleeder.df0cc179.png";